module.exports = __webpack_public_path__ + "static/media/ca.df5de280.svg";